/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { Injectable } from '@angular/core';

/**
 * Provides the AuthenticationApiConfiguration configuration object with a given root URL.
 */
export function provideAuthenticationApiConfiguration(rootUrl: string) {
  var config = new AuthenticationApiConfiguration();
  config.rootUrl = rootUrl;
  return {
    provide: AuthenticationApiConfiguration,
    useValue: config
  };
}

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class AuthenticationApiConfiguration {
  rootUrl: string = '';
}

/**
 * Parameters for `AuthenticationModule.forRoot()`
 */
export interface AuthenticationApiConfigurationParams {
  rootUrl?: string;
}
